import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {Container, Row, Col} from 'reactstrap';
import TextInput from '../../../Shared/TextInput/TextInput';
import Tooltip from '../../../Shared/Tooltip/Tooltip';
import {connect} from 'react-redux';
import {
  changeHandler,
  validateHandler,
  onCheck,
  onUncheck,
  termsMsg,
  isCreditCardError,
  creditCardData,
  setId,
  openPopover,
  closePopover,
  initValidation,
  reportAnalytics,
} from './PaymentSlice';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import {getCreditCardToken} from './GetCCToken';
import Loader from '../../../Shared/Loader/Loader';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';
import EpiContext from '@episerver/spa-core/Spa';
import PopOver from '../../../Shared/Popover/Popover';
import {prepareUrl} from '../../../../utilities/StringHelpers/StringHelpers';

const payment = (props) => {
  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.onSubmit) {
          props.validateHandler(props.form);
          props.onValid(false);
        }
      }
    },
    [props.onSubmit, props.form.valid]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.onSubmit) {
          props.validateHandler(props.form);
        }
      }
    },
    [props.onSubmit]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.valid && props.isTermsAccepted) {
          getCreditCardToken(props);
        }
      }
    },
    [props.form.valid, props.onSubmit]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.CCData.CCToken !== undefined && props.form.valid != '') {
          if (props.form.valid === true && props.isTermsAccepted === false) {
            props.termsMsg(true);
            props.onValid(false);
          }

          if (props.form.valid === true && props.isTermsAccepted === true) {
            props.termsMsg(false);
            props.onValid(true);
          }

          props.initValidation();
        }
      }
    },
    [props.CCData.CCToken, props.isValid]
  );

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.form.id === '') {
        props.setId(props.customerId);
      }
    }

    props.initValidation();
  }, []);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.isHideTermsCheckbox) {
          props.onCheck();
        }
      }
    },
    [props.isHideTermsCheckbox]
  );

  useEffect(() => {
    switch (props.saleType) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: 'visibility_24',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
        break;
      case 'app':
        props.reportAnalytics({
          eventCategory: 'app_newsale_process',
          eventAction: 'visibility_32',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
        break;
      case 'cellular':
        props.reportAnalytics({
          eventCategory: 'cellular_newsale_process',
          eventAction: 'visibility_27',
          eventLabel: 'screen_17',
        });
        break;
      case 'internet':
        props.reportAnalytics({
          eventCategory: 'fiber_newsale_process',
          eventAction: 'visibility_21',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
        break;
    }
  }, []);

  const paymentCountList = props.paymentCountList
    ? props.paymentCountList
    : [
        {value: '1', label: 'תשלום אחד'},
        {value: '2', label: '2 תשלומים בקרדיט'},
        {value: '3', label: '3 תשלומים בקרדיט'},
        {value: '4', label: '4 תשלומים בקרדיט'},
        {value: '5', label: '5 תשלומים בקרדיט'},
        {value: '6', label: '6 תשלומים בקרדיט'},
        {value: '7', label: '7 תשלומים בקרדיט'},
        {value: '8', label: '8 תשלומים בקרדיט'},
        {value: '9', label: '9 תשלומים בקרדיט'},
        {value: '10', label: '10 תשלומים בקרדיט'},
      ];

  const handlePaymentsAndEvents = (e) => {
    if (props.gaEventPayments) {
      props.gaEventPayments(e);
    }
    props.changeHandler({
      target: {
        name: 'paymentCount',
        value: e.value,
        label: e.label,
      },
      form: props.form,
    });
  };

  const colPadding = props.padding != undefined ? props.padding : '10px';

  return (
    <Container className='payment'>
      <Loader overlay={true} />
      <Row>
        <Col style={{paddingLeft: colPadding, paddingRight: colPadding}}>
          <div className='payment-form'>
            <Row>
              <Col className='details'>
                <div className='details__title'>פרטי כרטיס אשראי</div>
                <div className='details__ssl'>
                  רכישה מאובטחת ב-SSL <Image src={require('./images/lock.svg')} alt='מנעול' className='details__lock' />
                </div>
              </Col>
            </Row>
            <Row className='cards'>
              <Col>
                <Image src={require('./images/cards.svg')} alt='כרטיסי אשראי' className='cards__img' />
              </Col>
              <Col className='cards__note'>
                לא כולל
                <br /> כרטיסי דיירקט
              </Col>
            </Row>
            <div className='required-note'>
              <span className='required-note__text'>שדות עם כוכבית הם חובה</span>
            </div>
            <div className='form-container'>
              <TextInput
                required={true}
                name='userName'
                type='text'
                autoComplete='off'
                placeholder='למי שייך הכרטיס? (שם מלא)'
                value={props.form.userName}
                error={props.form.errors.userName}
                onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
              />
              <TextInput
                required={true}
                disabled={props.customerId ? true : false}
                autoComplete='off'
                name='id'
                type='number'
                pattern='[0-9]*'
                placeholder='תעודת זהות'
                maxLength='9'
                value={props.form.id}
                error={props.form.errors.id}
                onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
              />
              <TextInput
                required={true}
                autoComplete='off'
                name='CardNumber'
                type='number'
                pattern='[0-9]*'
                placeholder='מספר הכרטיס'
                maxLength='16'
                value={props.form.CardNumber}
                error={props.form.errors.CardNumber}
                onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
              />
              <Row className='expiry'>
                <Col className='expiry__title-container'>
                  <label className='expiry__title-text'>תוקף</label>
                </Col>
                <Col className='expiry__year__col'>
                  <div className='expiry__separator expiry__separator--first'></div>
                  <div className='expiry__year'>
                    <TextInput
                      required={true}
                      autoComplete='off'
                      name='CardDueYear'
                      type='number'
                      pattern='[0-9]*'
                      placeholder='שנה'
                      maxLength='2'
                      value={props.form.CardDueYear}
                      error={props.form.errors.CardDueYear}
                      onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                    />
                  </div>
                </Col>
                <Col className='expiry__month__col'>
                  <div className='expiry__separator expiry__separator--second'></div>
                  <div className='expiry__month'>
                    <TextInput
                      required={true}
                      autoComplete='off'
                      name='CardDueMonth'
                      type='number'
                      pattern='[0-9]*'
                      placeholder='חודש'
                      maxLength='2'
                      value={props.form.CardDueMonth}
                      error={props.form.errors.CardDueMonth}
                      onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                    />
                  </div>
                </Col>
              </Row>
              <div className='cvv'>
                <TextInput
                  required={true}
                  autoComplete='off'
                  name='CVV'
                  type='number'
                  pattern='[0-9]*'
                  placeholder='CVV'
                  maxLength='3'
                  value={props.form.CVV}
                  error={props.form.errors.CVV}
                  onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                />
                <Image src={require('./images/icon-question.svg')}
                  id='cvv-question-icon'
                  alt='סימן שאלה'
                  className='cvv-question-icon'
                  onClick={() => props.openPopover()} />
                <PopOver
                  className='cvv-popover'
                  placement='left'
                  text='3 ספרות בגב הכרטיס'
                  target='cvv-question-icon'
                  isOpen={props.togglePopover}
                  closePopover={() => props.closePopover()}
                />
              </div>
            </div>
            {props.showPaymentCount ? (
              <div className='select-holder'>
                <ReactSelect
                  placeholderColor='#4a4a4a'
                  error={props.form.errors.subject}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  placeholder='בחר סוג תשלום'
                  isLoading={false}
                  value={paymentCountList.filter((option) => option.value === props.form.paymentCount)}
                  name='paymentCount'
                  options={paymentCountList.slice(0, props.paymentRequestedQuantity)}
                  onChange={(e) => handlePaymentsAndEvents(e)}
                />
              </div>
            ) : null}
            {props.isHideTermsCheckbox ? null : (
              <Row className='termOfService'>
                <Col xs='2' md='1' className='termOfService__checkbox'>
                  <div>
                    <CheckBox
                      id='approveReceivingMsg'
                      onCheck={(e) => props.onCheck({target: e.target, receiveMsgs: props.receiveMsgs})}
                      onUncheck={() => {
                        props.onUncheck();
                      }}></CheckBox>
                  </div>
                </Col>
                <Col xs='10' md='10'>
                  <p className='termOfService__link'>
                    אני מאשר את{' '}
                    <span
                      className={`${props.isBusiness ? 'purple-link' : ''} termOfService__link__url`}
                      onClick={() => prepareUrl(props.termsLink, EpiContext)}>
                      תנאי השירות
                    </span>
                  </p>
                </Col>
                {props.isTermsMsg ? <div className='terms-error'>חובה לאשר את תנאי השירות </div> : null}
              </Row>
            )}
            {props.CCError ? <div className='cc-error'> לא הצלחנו לאמת את פרטי הכרטיס - כדאי לנסות כרטיס אחר</div> : null}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.Payment.form,
    CCData: state.Payment.CCData,
    isTermsAccepted: state.Payment.isTermsAccepted,
    isTermsMsg: state.Payment.isTermsMsg,
    CCError: state.Payment.CCError,
    togglePopover: state.Payment.togglePopover,
    saleType: state.saleBlock.saleType,
    productsInfo: state.saleBlock.productsInfo,
  };
};

const mapDispatchToProps = {
  changeHandler,
  validateHandler,
  onCheck,
  onUncheck,
  termsMsg,
  showAppLoader,
  hideAppLoader,
  isCreditCardError,
  creditCardData,
  setId,
  openPopover,
  closePopover,
  initValidation,
  reportAnalytics,
  getCreditCardToken,
};

export default connect(mapStateToProps, mapDispatchToProps)(payment);
